export class SidebarMenuModule {
  constructor() {

  }

  private accordions: any[] = [];

  init() {
    this.accordions = Array.from(document.querySelectorAll('.menu-sidebar'));

    let prev: any = null;

    this.accordions.forEach(el => {
      const sublist = el.querySelector('.menu-sidebar--list ul');
      if (!sublist) {
          return;
      }
      el.addEventListener('click', e => {
        if (sublist.contains(e.target)) {
            return;
        }

        if(el.classList.contains('active')){
          el.classList.toggle('active');
        }else{
          this.accordions.map( el => el.classList.remove('active'))
          if (prev) {
            prev.classList.remove('active')
          }
          el.classList.toggle('active');
          prev = el;
        }
      })
    })
  }
}
